module.exports = __webpack_public_path__ + "static/media/asurion-hero-tablet-big.3906566b.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-hero-tablet-big.jpg
// module id = 1384
// module chunks = 0